import React from 'react';
import { getAllSports } from '../data/exercises/index.js';
import SportGrid from './SportGrid';
import { useSelectedPlayers } from '../contexts/SelectedPlayersContext';

function SportSelection() {
  const sports = getAllSports();
  const { selectedPlayersData, removePlayer, addPlayer, allPlayersData } =
    useSelectedPlayers();

  const sportData = {
    soccer: {
      name: 'Soccer',
      icon: '⚽',
      color: '#4CAF50',
    },
    basketball: {
      name: 'Basketball',
      icon: '🏀',
      color: '#FF9800',
    },
    swimming: {
      name: 'Swimming',
      icon: '🏊',
      color: '#2196F3',
    },
    tennis: {
      name: 'Tennis',
      icon: '🎾',
      color: '#9C27B0',
    },
    volleyball: {
      name: 'Volleyball',
      icon: '🏐',
      color: '#F44336',
    },
    football: {
      name: 'Football',
      icon: '🏈',
      color: '#795548',
    },
    baseball: {
      name: 'Baseball',
      icon: '⚾',
      color: '#FF5722',
    },
    track: {
      name: 'Track & Field',
      icon: '🏃',
      color: '#607D8B',
    },
    gymnastics: {
      name: 'Gymnastics',
      icon: '🤸',
      color: '#E91E63',
    },
    martial_arts: {
      name: 'Martial Arts',
      icon: '🥷',
      color: '#3F51B5',
    },
    'martial-arts': {
      name: 'Martial Arts',
      icon: '🥷',
      color: '#3F51B5',
    },
    dance: {
      name: 'Dance',
      icon: '💃',
      color: '#FF4081',
    },
    lacrosse: {
      name: 'Lacrosse',
      icon: '🥍',
      color: '#8BC34A',
    },
    rugby: {
      name: 'Rugby',
      icon: '🏉',
      color: '#FF9800',
    },
    cricket: {
      name: 'Cricket',
      icon: '🏏',
      color: '#795548',
    },
    golf: {
      name: 'Golf',
      icon: '⛳',
      color: '#4CAF50',
    },
    hockey: {
      name: 'Hockey',
      icon: '🏒',
      color: '#2196F3',
    },
    karate: {
      name: 'Karate',
      icon: '🥋',
      color: '#3F51B5',
    },
    taekwondo: {
      name: 'Taekwondo',
      icon: '☯',
      color: '#3F51B5',
    },
    ballet: {
      name: 'Ballet',
      icon: '🩰',
      color: '#E91E63',
    },
    boxing: {
      name: 'Boxing',
      icon: '🥊',
      color: '#FF5722',
    },

    'movement-coordination': {
      name: 'Gymnastics',
      icon: '🤸',
      color: '#E91E63',
    },
    gymnastics: {
      name: 'Gymnastics',
      icon: '🤸',
      color: '#E91E63',
    },
    'running-technique': {
      name: 'Running Technique',
      icon: '🏃',
      color: '#607D8B',
    },
  };

  const sportItems = sports.map((sport) => {
    const sportInfo = sportData[sport] || {
      name: sport.charAt(0).toUpperCase() + sport.slice(1).replace('_', ' '),
      icon: '🏆',
      color: '#666',
    };

    return {
      icon: sportInfo.icon,
      title: sportInfo.name,
      color: sportInfo.color,
      link: sport,
    };
  });

  return (
    <SportGrid
      title='Choose Your Sport!'
      subtitle='Pick a sport to see available strength workouts'
      items={sportItems}
      showBackButton={true}
      backButtonText='← Back to Players'
      backButtonPath='/workouts/players'
      itemLinkPrefix='/workouts/sports/'
      selectedPlayers={selectedPlayersData}
      onRemovePlayer={removePlayer}
      onAddPlayer={addPlayer}
      allPlayers={allPlayersData}
    />
  );
}

export default SportSelection;
